import { render, staticRenderFns } from "./NoticeSettings.vue?vue&type=template&id=f594a5cc&scoped=true&"
import script from "./NoticeSettings.vue?vue&type=script&lang=ts&"
export * from "./NoticeSettings.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeSettings.vue?vue&type=style&index=0&id=f594a5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f594a5cc",
  null
  
)

export default component.exports